<template>
  <el-button 
    size="small" 
    plain 
    v-if="show"
    :disabled="disabled"
    :icon="icon" 
    :class="icon == 'icon icon-rubbish' ? 'color-red' : ''"
    @click="handleClick">
    <slot></slot>
  </el-button>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
    permissionKey: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default () {
        switch (this.permissionKey) {
          case 'create':
            return 'icon icon-plus'
          case 'update':
            return 'icon icon-edit'
          case 'delete':
            return 'icon icon-rubbish'
          default:
            return 'icon'
        }
      }
    }
  },
  methods: {
    handleClick (evt) {
      this.$emit('click', evt)
    }
  },
  computed: {
    show () {
      return this.permissionKey === '' || this.$_g_hasPermission(this.permissionKey)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/operate-button.vue